import { render, staticRenderFns } from "./depositModel.vue?vue&type=template&id=864303e2"
import script from "./depositModel.vue?vue&type=script&lang=js"
export * from "./depositModel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports